import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
interface FooterSectionProps {
  language: 'en' | 'es';
}
export function FooterSection({
  language
}: FooterSectionProps) {
  return <footer className="bg-luxury-bg pt-20 pb-10 border-t border-gold-primary/20 relative" data-id="element-52">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-53">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16" data-id="element-54">
          {/* Brand Col */}
          <div className="col-span-1" data-id="element-55">
            <div className="flex items-center gap-3 mb-6" data-id="element-56">
              <svg viewBox="0 0 100 120" className="w-8 h-10 text-gold-primary fill-current" data-id="element-57">
                <path d="M50 0 L100 20 L100 70 L50 120 L0 70 L0 20 Z" fill="none" stroke="currentColor" strokeWidth="6" data-id="element-58" />
                <text x="50" y="72" textAnchor="middle" fontSize="42" fontFamily="serif" fontWeight="bold" fill="currentColor" data-id="element-59">
                  MP
                </text>
              </svg>
              <div className="flex flex-col" data-id="element-60">
                <span className="font-serif text-xl font-bold text-warm-white leading-none tracking-wide" data-id="element-61">
                  MAINPOINT
                </span>
                <span className="font-sans text-[0.6rem] font-medium text-gold-light tracking-[0.2em] uppercase mt-1" data-id="element-62">
                  Multiservices
                </span>
              </div>
            </div>
            <p className="text-warm-gray text-sm leading-relaxed max-w-xs" data-id="element-63">
              {language === 'en' ? 'Premium financial and insurance solutions tailored for individuals and businesses demanding excellence.' : 'Soluciones financieras y de seguros premium adaptadas para individuos y empresas que exigen excelencia.'}
            </p>
            <div className="mt-6 pt-6 border-t border-gold-dark/20" data-id="element-64">
              <p className="font-serif text-warm-white font-semibold text-base" data-id="element-65">
                Mariana Salazar
              </p>
              <p className="text-gold-light text-xs tracking-[0.15em] uppercase mt-1" data-id="element-66">
                {language === 'en' ? 'Licensed Insurance & Auto Sales Agent' : 'Agente de Seguros y Venta de Autos'}
              </p>
            </div>
          </div>

          {/* Contact Col */}
          <div className="col-span-1" data-id="element-67">
            <h4 className="font-serif text-lg text-warm-white mb-6" data-id="element-68">
              {language === 'en' ? 'Contact' : 'Contacto'}
            </h4>
            <ul className="space-y-4" data-id="element-69">
              <li data-id="element-70">
                <a href="https://wa.me/19549804584" target="_blank" rel="noopener noreferrer" className="flex items-center text-warm-gray hover:text-gold-light transition-colors text-sm" data-id="element-71">
                  <Phone className="w-4 h-4 mr-3 text-gold-primary" data-id="element-72" />
                  +1 (954) 980-4584
                </a>
              </li>
              <li data-id="element-73">
                <a href="mailto:info@mainpointusa.com" className="flex items-center text-warm-gray hover:text-gold-light transition-colors text-sm" data-id="element-74">
                  <Mail className="w-4 h-4 mr-3 text-gold-primary" data-id="element-75" />
                  info@mainpointusa.com
                </a>
              </li>
              <li className="flex items-start text-warm-gray text-sm" data-id="element-76">
                <MapPin className="w-4 h-4 mr-3 text-gold-primary shrink-0 mt-0.5" data-id="element-77" />
                <span data-id="element-78">
                  Miami, FL
                  <br data-id="element-79" />
                  {language === 'en' ? 'By Appointment Only' : 'Solo con Cita Previa'}
                </span>
              </li>
              <li data-id="element-80">
                <a href="https://www.instagram.com/marianasalazaarl/" target="_blank" rel="noopener noreferrer" className="flex items-center text-warm-gray hover:text-gold-light transition-colors text-sm" data-id="element-81">
                  <svg className="w-4 h-4 mr-3 text-gold-primary flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" data-id="element-82">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" data-id="element-83" />
                    <circle cx="12" cy="12" r="4" data-id="element-84" />
                    <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none" data-id="element-85" />
                  </svg>
                  @marianasalazaarl
                </a>
              </li>
            </ul>
          </div>

          {/* Links Col */}
          <div className="col-span-1" data-id="element-86">
            <h4 className="font-serif text-lg text-warm-white mb-6" data-id="element-87">
              {language === 'en' ? 'Quick Links' : 'Enlaces Rápidos'}
            </h4>
            <ul className="space-y-3" data-id="element-88">
              <li data-id="element-89">
                <a href="#services" className="text-warm-gray hover:text-gold-light transition-colors text-sm uppercase tracking-wider" data-id="element-90">
                  {language === 'en' ? 'Services' : 'Servicios'}
                </a>
              </li>
              <li data-id="element-91">
                <a href="#comparison" className="text-warm-gray hover:text-gold-light transition-colors text-sm uppercase tracking-wider" data-id="element-92">
                  {language === 'en' ? 'Why Us' : 'Por Qué Nosotros'}
                </a>
              </li>
              <li data-id="element-93">
                <a href="#process" className="text-warm-gray hover:text-gold-light transition-colors text-sm uppercase tracking-wider" data-id="element-94">
                  {language === 'en' ? 'Process' : 'Proceso'}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gold-dark/20 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-95">
          <p className="text-warm-gray text-xs" data-id="element-96">
            &copy; {new Date().getFullYear()} MainPoint Multiservices.{' '}
            {language === 'en' ? 'All rights reserved.' : 'Todos los derechos reservados.'}
          </p>
          <a href="https://www.instagram.com/marianasalazaarl/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-warm-gray hover:text-gold-light transition-colors text-xs" data-id="element-97">
            <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" data-id="element-98">
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5" data-id="element-99" />
              <circle cx="12" cy="12" r="4" data-id="element-100" />
              <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none" data-id="element-101" />
            </svg>
            @marianasalazaarl
          </a>
          <div className="flex gap-4 text-xs text-warm-gray" data-id="element-102">
            <a href="#" className="hover:text-gold-light transition-colors" data-id="element-103">
              {language === 'en' ? 'Privacy Policy' : 'Política de Privacidad'}
            </a>
            <span className="text-gold-dark/50" data-id="element-104">|</span>
            <a href="#" className="hover:text-gold-light transition-colors" data-id="element-105">
              {language === 'en' ? 'Terms of Service' : 'Términos de Servicio'}
            </a>
          </div>
        </div>
      </div>
    </footer>;
}